import { render, staticRenderFns } from "./DiscountCodes.vue?vue&type=template&id=e2f94408&scoped=true&"
import script from "./DiscountCodes.js?vue&type=script&lang=js&"
export * from "./DiscountCodes.js?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&id=e2f94408&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f94408",
  null
  
)

/* custom blocks */
import block0 from "./DiscountCodes.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fcomponents%2Fcommon%2FCartLike%2FDiscountCodes%2FDiscountCodes.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports